import { type SvgProps, SvgWrapper } from '../utils';
export function UnfoldLessIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11.5264 14.418C11.8209 14.1777 12.2557 14.1951 12.5303 14.4697L17.5303 19.4697C17.8232 19.7626 17.8232 20.2374 17.5303 20.5303C17.2374 20.8232 16.7626 20.8232 16.4697 20.5303L12 16.0605L7.53027 20.5303C7.23738 20.8232 6.76262 20.8232 6.46972 20.5303C6.17683 20.2374 6.17683 19.7626 6.46972 19.4697L11.4697 14.4697L11.5264 14.418Z" />
      <path d="M16.4697 3.46967C16.7626 3.17678 17.2374 3.17678 17.5303 3.46967C17.8232 3.76256 17.8232 4.23732 17.5303 4.53022L12.5303 9.53022C12.2374 9.82311 11.7626 9.82311 11.4697 9.53022L6.46972 4.53022C6.17683 4.23732 6.17683 3.76256 6.46972 3.46967C6.76262 3.17678 7.23738 3.17678 7.53027 3.46967L12 7.9394L16.4697 3.46967Z" />
    </SvgWrapper>
  );
}
